"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@pex/ui-web";
import Image from "next/image";

const TESTIMONIALS = [
  {
    quote:
      "\u201CAs a supporter, I thought I had all the answers, but after joining PEx, I realised that I had a lot of unresolved issues. The group taught me how to become emotionally and mentally healthy.\u201D",
    name: "Jo Ann Latt",
    avatar: "/images/testimonials/Mountains_310_Mount_Kilimanjaro_zc5lg1.webp",
  },
  {
    quote:
      "\u201CMy recovery as a supporter began the moment I found myself completely broken and knew I had to surrender to unfamiliar and uncomfortable ways in order to rebuild myself into who I was always meant to be. Through the help of Project Exodus I have experienced healing and freedom.\u201D",
    name: "Nerina Francis",
    avatar: "/images/testimonials/Mountains_312_Mount_Rainier_igng7c.webp",
  },
  {
    quote:
      "\u201CIt has been an enlightening course and definitely opened my eyes to some wrong beliefs and stinky thinking. I\u2019ve definitely grown through it. I will forever be grateful for this invaluable wisdom.\u201D",
    name: "Graig Botha",
    avatar: "/images/testimonials/Flowers_447_Flowers_5esazb.webp",
  },
  {
    quote:
      "\u201CWalking recovery as a supporter. Project Exodus has been essential in changing how I walk recovery. Change is fundamental and an ongoing process.\u201D",
    name: "Wendy Hodgson",
    avatar: "/images/testimonials/Flowers_436_Watering_can_jvcvnu.webp",
  },
  {
    quote:
      "\u201CBeing a Recovery Supporter has been a wonderful journey in learning more about myself, finally being able to put down boundaries and gaining the best support structure.\u201D",
    name: "Monique Martins",
    avatar:
      "/images/testimonials/Lakes__Rivers___Waterfalls_397_Yangtze_river_kyka9e.webp",
  },
] as const;

const STAR_KEYS = ["1", "2", "3", "4", "5"] as const;

function StarRating() {
  return (
    <div aria-label="5 out of 5 stars" className="flex gap-0.5" role="img">
      {STAR_KEYS.map((n) => (
        <svg
          aria-hidden="true"
          className="h-5 w-5 fill-amber-400 text-amber-400"
          key={n}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function ResoundTestimonialsCarousel() {
  return (
    <div className="relative">
      {/* Edge fade overlays — pointer-events-none so cards/buttons remain interactive */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 bottom-16 left-0 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 bottom-16 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to left, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent className="-ml-4">
          {TESTIMONIALS.map((t) => (
            <CarouselItem className="pl-4 md:basis-1/2" key={t.name}>
              <div className="flex h-full flex-col gap-4 rounded-2xl border bg-card p-6 shadow-sm">
                <StarRating />
                <p className="body-base flex-1">{t.quote}</p>
                <div className="flex items-center gap-3">
                  <div className="relative h-9 w-9 shrink-0 overflow-hidden rounded-full">
                    <Image
                      alt=""
                      className="object-cover"
                      fill
                      sizes="36px"
                      src={t.avatar}
                    />
                  </div>
                  <span className="font-semibold text-sm">{t.name}</span>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="mt-6 flex items-center gap-2 px-1">
          <CarouselPrevious className="static translate-y-0" />
          <CarouselNext className="static translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
}
